import type { PreviewUploadsController } from '../../../../hooks/useDappFileHandlers';
import { PreviewUploadsField as SharedPreviewUploadsField } from '../../../dapp-form/PreviewUploadsField';
import { MediaUploadWithExisting } from '../../MediaUploadWithExisting';
import type { FormState } from '../types';

interface PreviewUploadsFieldProps {
  dappPreviews: FormState['dappPreviews'];
  previewUploads: PreviewUploadsController;
  existingPreviewUrls: (string | null)[];
  resolvedPreviewUrls: (string | null)[];
  onRemoveExistingPreview: (index: number) => void;
}

export function PreviewUploadsField({
  dappPreviews,
  previewUploads,
  existingPreviewUrls,
  resolvedPreviewUrls,
  onRemoveExistingPreview,
}: PreviewUploadsFieldProps) {
  return (
    <SharedPreviewUploadsField
      dappPreviews={dappPreviews}
      existingPreviewUrls={existingPreviewUrls}
      previewDimensions={previewUploads.previewDimensions}
      orientation={previewUploads.orientation}
      isOrientationLocked={previewUploads.isOrientationLocked}
      isResolvingOrientation={previewUploads.isResolvingOrientation}
      onOrientationChange={previewUploads.setOrientation}
      onFilesSelected={previewUploads.handlePreviewFilesChange}
      renderUploadSlot={(index) => (
        <MediaUploadWithExisting
          name={`dappPreview-${index}`}
          value={dappPreviews[index] ?? null}
          existingUrl={resolvedPreviewUrls[index] ?? null}
          onChange={(file: File | null) =>
            previewUploads.handlePreviewFileChange(index, file)
          }
          onRemoveExisting={() => onRemoveExistingPreview(index)}
          placeholderClassName="absolute inset-0"
          buttonType="add"
        />
      )}
    />
  );
}
